export default (fileList, result, err) => {
    const reader = new FileReader();

    reader.readAsDataURL(fileList[0]);

    reader.onload = function () {
        result(reader.result);
    };
    reader.onerror = function (error) {
        err(error);
    };
};

export function readMultiFiles(fileList, success, error) {
    const reader = new FileReader();
    const fileResults = [];

    function readFile(index) {
        if (index >= fileList.length) return;

        const file = fileList[index];

        reader.onload = function (e) {
            fileResults.push({ name: file.name, value: e.target.result });
            readFile(index + 1);
            success(fileResults);
        };

        reader.onerror = function (err) {
            error(err);
        };

        reader.readAsDataURL(file);
    }
    readFile(0);
}
